document.addEventListener("scroll", () => {
  const header = document.querySelector("header");
  if (window.scrollY > 0) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }
});

var menu_open = false;

document.addEventListener("DOMContentLoaded", function () {
  let menu = document.querySelector(".header__primary-menu");
  let burger = document.querySelector(".header__mobile > svg");
  let menu_bg = document.querySelector(".header__mobile_bg");
  let header = document.querySelector("header.header");

  if (menu && burger && menu_bg) {
    burger.addEventListener("click", function (e) {
      e.preventDefault();
      let c = this.classList;

      if (c.contains("active")) {
        __close_mobile_menu();
      } else {
        menu_open = true;
        c.add("active");
        menu.classList.add("active");
        menu_bg.classList.add("active");
        header.classList.add("active");
        menu.style.setProperty("--header-h", `${header.offsetHeight}px`);
        document.body.style.overflow = "hidden";
      }
    });
  }

  menu.querySelectorAll('a').forEach((item) => {
    item.addEventListener("click", () => {
      return menu_open ? __close_mobile_menu() : false;
    });
  });

  menu_bg.addEventListener("click", () => {
    return menu_open ? __close_mobile_menu() : false;
  });

  window.addEventListener("resize", () => {
    return menu_open ? __close_mobile_menu() : false;
  });

  function __close_mobile_menu() {
    burger.classList.remove("active");
    menu.classList.remove("active");
    menu_bg.classList.remove("active");
    header.classList.remove("active");
    document.body.style.overflow = "";
    menu_open = false;
  }
});

(function ($) {
  $(document).ready(function () {

    function smoothScroll(target) {
      var $el = $(target);
      if ($el.length) {
        $('html, body').animate({ scrollTop: $el.offset().top }, 600);
      }
    }

    $('a').on('click', function (e) {
      var href = $(this).attr('href');
      if (!href) return;

      if (href.startsWith('#')) {
        e.preventDefault();
        smoothScroll(href);
        return;
      }

      var urlParts = href.split('#');
      var base = urlParts[0];
      var hash = urlParts[1] ? '#' + urlParts[1] : null;

      var currentBase = window.location.origin + window.location.pathname;

      if (getBaseUrl(base) === currentBase) {
        if (hash) {
          e.preventDefault();
          smoothScroll(hash);
        }
      }

      function getBaseUrl(url) {
        var link = document.createElement('a');
        link.href = url;
        return link.origin + link.pathname;
      }
    });

    // Якщо при завантаженні сторінки вже є хеш
    if (window.location.hash) {
      smoothScroll(window.location.hash);
    }

  });
})(jQuery);